export const creativesRoutes = {
  path: '/creatives',
  children: [
    {
      name: 'creatives',
      path: '',
      component: () => import('pages/Creatives/Creatives/index.vue'),
      meta: {
        title: 'Creatives',
      },
    },
    {
      name: 'newCreative',
      path: 'new',
      component: () => import('pages/Creatives/NewCreative/index.vue'),
      meta: {
        title: 'New Creative',
      },
    },
    {
      name: 'editCreative',
      path: ':id/edit',
      component: () => import('pages/Creatives/EditCreative/index.vue'),
      meta: {
        title: 'Edit Creative',
      },
    },
  ],
}
